<template>
  <button
    type="button"
    class="group-toggle-button"
    :class="{
      active: expanded,
      'is-disabled': disabled,
    }"
    :title="title"
    :aria-label="title"
    :aria-disabled="disabled ? 'true' : 'false'"
    @click="toggle"
  >
    <i :class="iconClass" />
    <span>{{ title }}</span>
  </button>
</template>

<script>
export default {
  props: {
    expanded: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    title() {
      return this.expanded
        ? this.$l('btn_collapse_all_groups') || '全部收起'
        : this.$l('btn_expand_all_groups') || '全部展开'
    },
    iconClass() {
      return this.expanded ? 'el-icon-top' : 'el-icon-bottom'
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return
      this.$emit('toggle')
    },
  },
}
</script>

<style scoped>
.group-toggle-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 0 10px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #64748b;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  font-family: inherit;
  flex-shrink: 0;
  white-space: nowrap;
}

.group-toggle-button i {
  font-size: 13px;
}

.group-toggle-button:hover {
  background: #e2e8f0;
  color: #334155;
}

.group-toggle-button.active {
  background: #fff;
  border-color: #bfdbfe;
  color: #2563eb;
}

.group-toggle-button.is-disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.group-toggle-button.is-disabled:hover {
  background: #f1f5f9;
  color: #64748b;
}
</style>
